import React, { useState } from "react";

const useVeladasGraph = (validation) => {
  const [configModal, setConfigModal] = useState({ show: false });

  const completeConfigHandler = (horarioVelada) => {
    validation.setFieldValue("time", horarioVelada);
    setConfigModal({ show: false });
  };

  return {
    configModal,
    setConfigModal,
    completeConfigHandler,
  };
};

export default useVeladasGraph;
